import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavigationService } from '../../navigation/navigation.service';
import { NavigationSlugs } from '../../navigation/navigation-slugs';
import { LogoService } from '@core/services/logo.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppNotificationService } from '@core/services/app-notification.service';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class DmyvAuthGuard implements CanLoad, CanActivate {
    constructor(private authService: AuthService,
                private logoService: LogoService,
                private navigationService: NavigationService,
                private appNotificationService: AppNotificationService) {
    }

    canLoad(): Observable<boolean> {
        return this.isAccessAllowed();
    }

    canActivate(): Observable<boolean> {
        return this.isAccessAllowed();
    }

    isAccessAllowed(): Observable<boolean> {
        return this.authService
            .userData$
            .pipe(
                take(1),
                map(userData => {
                const roles = userData?.groups ||  [];
                const result = roles.includes('dmyv_admin') || roles.includes('dmyv_sbv_admin');

                if (result) {
                    this.navigationService.changeNavigationTo(NavigationSlugs.MainDmyv);
                    this.logoService.showDmyvLogo();
                } else {
                    this.appNotificationService.showError('Zugriff verweigert.');
                }

                return result;
                })
            );
    }
}
